import React, { useState, useEffect } from 'react';

import { TableColumnType, TableFilterType, DynamicTable } from '../../components';
import { HttpService, UtilityService } from '../../services';

const AuditConfigurationDetails = ({ colSpan, result }) => {
    let formattedConfiguration = result.configurationJson;
    try {
        formattedConfiguration = JSON.stringify(JSON.parse(result.configurationJson), null, 2);
    } catch (error) {
        formattedConfiguration = result.configurationJson;
    }

    const copyConfiguration = () => navigator.clipboard.writeText(formattedConfiguration);

    return (
        <tr>
            <td colSpan={colSpan}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <strong>Configuration sent</strong>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={copyConfiguration}>
                        Copy JSON
                    </button>
                </div>
                <pre className="bg-light p-3 text-left" style={{ whiteSpace: 'pre-wrap', userSelect: 'text' }}>
                    {formattedConfiguration}
                </pre>
            </td>
        </tr>
    );
};

export const Audits = () => {
    const [auditTypes, setAuditTypes] = useState([]);
    const columns = [
        {
            name: 'raisedOn',
            text: 'Event Date',
            dataType: TableColumnType.DateTime
        },
        {
            name: 'name',
            text: 'Audit type',
            dataType: TableColumnType.Text,
            filterType: TableFilterType.List,
            filterList: auditTypes,
            filterListKey: 'key',
            filterListValue: 'value'
        },
        {
            name: 'description',
            text: 'Description',
            dataType: TableColumnType.Text
        },
        {
            name: 'triggeredBy',
            text: 'Triggered By',
            dataType: TableColumnType.Text,
            filterType: TableFilterType.Text
        },
        {
            name: 'raisedOn',
            text: 'Event Date',
            dataType: TableColumnType.DateTime,
            filterType: TableFilterType.DateRange,
            filterOnly: true
        }
    ];

    const tableText = {
        perPageLabel: 'Audits per page',
        totalCountLabel: 'Total Audits'
    };
    useEffect(() => {
        HttpService.get('/Audit/GetAuditTypes').then(response => setAuditTypes(UtilityService.objectToArray(response.data)));
    }, []);

    const formatHttpError = httpError => {
        if (httpError && httpError.response.data) {
            if (httpError.response.data['Filter.ToDate']) {
                return 'To date should be greater than from date.';
            }
        }
    };

    return (
        <DynamicTable
            tableColumns={columns}
            apiUrl={'/Audit/GetAudits'}
            filterButtonText="Filter Audits"
            tableText={tableText}
            formatHttpError={formatHttpError}
            defaultOrderColumn={4}
            isRowExpandable={result => Boolean(result.configurationJson)}
            RowDetailsTemplate={AuditConfigurationDetails}
        />
    );
};
